import type { AdItem } from '@sbt-web/network/types';
import { sendEvent as trackListingPageView } from '@/tools/tracking/AdSearchTracking';
import {
  buildCardClickTrackingData,
  buildCardImpressionTrackingViewData,
  TrackingItem,
} from '@/tools/tracking/adsListingImpressionsTracking/buildCardImpressionTrackingData';
import { getOrCreatePulse } from '@/tools/tracking/utils';

const trackView = async (items: Array<AdItem>, rank: number): Promise<void> =>
  trackListingPageView({
    eventType: 'View',
    objectType: 'RecommendationList',
    objectId: `sdrn:subito:listing:${window?.location?.href}:element:geoboosted-carousel`,
    rank,
    items,
  });

const trackImpression = (items: Array<AdItem>, rank: number): Promise<void> =>
  trackListingPageView({
    eventType: 'Watch',
    objectType: 'RecommendationList',
    objectId: `sdrn:subito:listing:${window?.location?.href}:element:geoboosted-carousel`,
    rank,
    items,
  });

const trackCardClick = async (trackingItem: TrackingItem): Promise<void> =>
  getOrCreatePulse()?.queueEvent(buildCardClickTrackingData(trackingItem));

const trackCardImpression = async (trackingItem: TrackingItem): Promise<void> =>
  getOrCreatePulse()?.queueEvent(
    buildCardImpressionTrackingViewData(trackingItem)
  );

export { trackView, trackImpression, trackCardClick, trackCardImpression };
